export const AdditionalInfoPageContentFi = () => {
  return (
    <>
      <h2>Tietosisältö</h2>

      <p>
        Sivustolla esitettävä tieto pohjautuu Euroopan ympäristökeskuksen (EEA)
        ylläpitämään{' '}
        <a
          href="https://www.eea.europa.eu/data-and-maps/data/industrial-reporting-under-the-industrial-3"
          target="blank">
          tietokantaan
        </a>
        . Tietokanta sisältää tietoja suomalaisten teollisuuslaitosten
        tärkeimmistä epäpuhtauspäästöistä ilmaan ja veteen seuraavilta
        teollisuudenaloilta:
      </p>
      <ul>
        <li>Energiateollisuus</li>
        <li>Metallien tuotanto ja jalostus</li>
        <li>Mineraaliteollisuus</li>
        <li>Kemianteollisuus</li>
        <li>Jäte- ja jätevesihuolto</li>
        <li>Metsäteollisuus</li>
        <li>Kotieläintuotanto ja vesiviljely</li>
        <li>Elintarvike- ja rehuteollisuus</li>
        <li>Muu toiminta</li>
      </ul>
      <p>
        Laitoksen on ilmoitettava päästöt, jos sen toiminnalle tai
        yhdistekohtaisille päästöille asetetut kynnysarvot ylittyvät.
        PRTR-rekisteriin ei sisällytetä muiden toimintojen kuin
        PRTR-raportointiin kuuluvia päästöjä, ei siis esimerkiksi liikenteen,
        maatalouden tai kotitalouksien päästöjä. Laitoksen ilmoittamat päästöt
        sisältävät myös mahdolliset poikkeuksellisten tilanteiden päästöt (esim.
        häiriö prosessissa tai rajoitustekniikassa), mutta näitä ei
        esitettävissä tiedoissa eritellä.
      </p>
      <p>
        Hiilidioksidipäästöt esitetään fossiilisen ja bioperäisen hiilidioksidin
        kokonaissummana ja lisäksi esitetään fossiilisen hiilidioksidin päästöt.
        Hakutoiminnoissa <i>hiilidioksidi (pois lukien biologinen)</i>{' '}
        tarkoittaa fossiilista hiilidioksidia, jota syntyy fossiilisten
        polttoaineiden käytöstä. Bioperäistä hiilidioksidia, jota syntyy
        biomassan polttamisesta, ei sisällytetä päästöjen kansainvälisiin
        vähennysvelvoitteisiin (mm. ilmastosopimukseen).
      </p>
      <p>
        Laitokset ilmoittavat vuosittain tiedot ilma- ja vesipäästöistä
        PRTR-pöytäkirjan liitteessä 5 luetelluista 91 yhdisteestä, jos päästöt
        ylittävät kynnysarvot sekä lisäksi tietoja jätesiirroista. Suomessa
        ilmoitetaan jätesiirrot Euroopan jäteluettelon mukaisesti (muualla
        rekisteriin voidaan vaihtoehtoisesti ilmoittaa myös jätteiden sisältämät
        kemikaalit). Liitteen 5 yhdisteiden lisäksi voidaan kansallisesti
        ilmoittaa muitakin päästötietoja. Rekisteri sisältää 65 toimialaa.
      </p>

      <h2>Päästörekisterien lyhyt historia</h2>

      <p>
        Ympäristövaikutuksia koskevan tiedon tarjoaminen kansalaisille oli
        mukana jo vuoden 1992 Rion julistuksessa.  Vuonna 1998 tuli voimaan YK:n
        Euroopan talouskomission yleissopimus tiedon saatavuudesta, kansalaisten
        osallistumisoikeudesta päätöksentekoon ja muutoksenhaku- ja
        vireillepano-oikeudesta ympäristöasioissa (Århusin yleissopimus).
        Ympäristöä koskevien tietojen tulee olla julkisesti saatavilla
        pyydettäessä tai aktiivisen levittämisen avulla esim. sähköisessä
        muodossa kansallisilla kielillä. Päästötietoja esitetään terveydelle tai
        luonnolle haitallisista päästöistä, joita rajoitetaan lainsäädännöllä ja
        joita  toiminnanharjoittajien on velvollisuus tarkkailla. Sopimus astui
        voimaan 2001, jolloin sen oli ratifioinut 17 maata etupäässä
        Itä-Euroopasta ja Keski-Aasiasta. Suomi allekirjoitti Århusin sopimuksen
        vuonna 1998 ja ratifioi sen 2004, jolloin sopimus astui voimaan Suomessa
        – tosin Suomen lainsäädäntö täytti sopimuksen vaatimukset jo
        aikaisemminkin. EU allekirjoitti sopimuksen 1998 ja  ratifioi sen 2005.
         Tällä hetkellä sopimuksen on ratifioinut tai hyväksynyt noin{' '}
        <a
          href="https://treaties.un.org/Pages/ViewDetails.aspx?src=IND&mtdsg_no=XXVII-13&chapter=27&clang=_en#1"
          target="blank">
          50 valtiota
        </a>
        . 
      </p>
      <p>
        {' '}
        Århusin sopimuksen Kiovan pöytäkirja on ensimmäinen päästö- ja
        jätesiirtorekistereitä koskeva laillisesti sitova kansainvälinen
        asiakirja (Pollutant Release and Transfer Register, PRTR), jonka
        tarkoituksena on lisätä ympäristötiedon saatavuutta mm. muodoltaan
        yhtenäisten kansallisten rekistereiden avulla ja se antaa yrityksille
        mahdollisuuden osoittaa, että ne toimivat ympäristötietoisesti
        seuraamalla toimintansa päästöjä. Suomi allekirjoitti Kiovan pöytäkirjan
        vuonna 2003 (samana vuonna kuin EU) ja ratifioi sen vuonna 2009, EU
        vuonna 2006. Pöytäkirja on ensimmäinen päästö- ja siirtorekistereitä
        koskeva laillisesti sitova kansainvälinen asiakirja. Sen tarkoituksena
        on lisätä ympäristötiedon saatavuutta mm. muodoltaan yhtenäisten
        kansallisten päästö- ja siirtorekistereiden (PRTR) välityksellä.
        Rekisteri antaa yrityksille mahdollisuuden antaa tietoa yleisölle ja
        osoittaa, että ne toimivat ympäristötietoisesti seuraamalla toimialansa
        pilaantumistietoja.{' '}
      </p>
      <p>
        {' '}
        EU perusti vuonna 2000 Euroopan päästörekisterin (European Pollutant
        Emission Register, EPER) ympäristön pilaantumisen ehkäisemisestä ja
        vähentämisestä 1996 annetun IPCC-direktiivin pohjalta. EPERin seuraaja
        Euroopaan päästö- ja jätesiirtorekisteri (European Pollutant Release and
        Transfer Register E-PRTR) perustettiin vuonna 2006. Suomalaisten
        laitosten tiedot on ilmoitettu alusta lähtien molempiin rekistereihin.
        2021 lähtien päästötiedot ovat saatavilla EEA:n ylläpitämässä{' '}
        <a href="https://industry.eea.europa.eu/" target="blank">
          teollisuuspäästöportaalissa
        </a>
        .
      </p>

      <p>
        <a
          href="https://unece.org/DAM/env/pp/EU%20texts/conventioninfinnish.pdf"
          target="blank">
          Århusin sopimus
        </a>
        &nbsp;(pdf 50 kt)
      </p>
      <p>
        <a
          href="https://ec.europa.eu/environment/industry/stationary/e-prtr/pdf/fi_prtr.pdf"
          target="blank">
          Neuvoston päätös PRTR
        </a>
        &nbsp;(pdf 115 kt)
      </p>

      <h2>Ympäristöluvat</h2>

      <p>
        Ympäristön pilaantumisen vaaraa aiheuttaville toiminnoille tarvitaan
        ympäristönsuojelulain mukainen lupa. Voit etsiä palvelussa esitettävien
        laitosten ympäristölupia Lupa- ja valvontaviraston{' '}
        <a href="https://ytietopalvelu.lvv.fi/fi-FI" target="blank">
          Ympäristöasioiden tietopalvelun
        </a>{' '}
        avulla.
      </p>

      <h2>Paras käyttökelpoinen tekniikka</h2>

      <p>
        Teollisuuspäästödirektiivin soveltamisalaan kuuluvien laitosten
        päästöraja-arvot, tarkkailu ja muut lupamääräykset perustuvat parhaaseen
        käyttökelpoiseen tekniikkaan. Sillä tarkoitetaan mahdollisimman
        tehokkaita ja kehittyneitä, teknisesti ja taloudellisesti
        toteuttamiskelpoisia tuotanto- ja puhdistusmenetelmiä ja toiminnan
        suunnittelu-, rakentamis-, ylläpito-, käyttö- sekä lopettamistapoja,
        joilla voidaan ehkäistä toiminnan aiheuttama ympäristön pilaantuminen
        tai tehokkaimmin vähentää sitä ja jotka soveltuvat
        ympäristölupamääräysten perustaksi. Euroopan komission organisoiman
        teollisuuden ja viranomaisten välisen tietojen vaihdon tuloksena
        julkaistaan BAT-vertailuasiakirjoja ja jäsenmaita sitovia BAT
        -päätelminä. Vertailuasiakirjat ja BAT-päätelmät löytyvät{' '}
        <a href="https://eippcb.jrc.ec.europa.eu/reference" target="blank">
          Euroopan IPPC-toimiston sivuilta
        </a>
        . Lisätietoja on{' '}
        <a
          href="https://www.ymparisto.fi/fi/kestava-kierto-ja-biotalous/kestava-tuotanto/paras-kayttokelpoinen-tekniikka-bat"
          target="blank">
          Suomen ympäristökeskuksen sivuilla
        </a>
        .
      </p>

      <h2>Sivuston tiedot</h2>

      <p>
        Suomen ympäristökeskus on toteuttanut sivuston ympäristöministeriön
        toimeksiannosta. Palautetta päästötiedoista ja muista sisältöä
        koskevista asioista voi lähettää valvontaviranomaisille (
        <a href="https://lvv.fi/ymparisto/" target="blank">
          Lupa- ja valvontavirasto
        </a>
        ). Sivuston teknisestä toiminnasta voi lähettää palautetta tai
        kehitysehdotuksia osoitteeseen{' '}
        <a href="mailto:PRTR@syke.fi">PRTR@syke.fi</a>.
      </p>

      <p>
        <a href="Käyttöehdot.pdf" target="blank">
          Palvelun käyttöehdot
        </a>
      </p>
      <p>
        <a href="Palveluseloste.pdf" target="blank">
          Palveluseloste
        </a>
      </p>
    </>
  )
}
